<script lang="ts">
    import { primary } from "../theme";

    export let steps: string[];
    export let step: number;
    export let onChangeStep: (nextStep: number) => void;

    const onSelectStep = (nextStep: number) => {
        if (nextStep === step) {
            return;
        }
        step = nextStep;
        onChangeStep(nextStep);
    };
</script>

<div class="root-container">
    {#each steps as stepName, i}
        <div
            on:click={() => onSelectStep(i)}
            class="circle"
            style="border-color: {step === i ? primary : null};"
        >
            {i + 1}
            <span
                class="step-name"
                style="color: {step === i ? primary : null};">{stepName}</span
            >
        </div>
        {#if i !== steps.length - 1}
            <div class="line" />
        {/if}
    {/each}
</div>

<style lang="scss">
    @import "theme.scss";

    .root-container {
        width: 100%;
        min-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.25rem;
        margin-bottom: 2rem;
    }

    .circle {
        height: 32px;
        width: 32px;
        border-radius: 32px;
        border: 2px solid $dark;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;

        &:hover {
            background: lighten($background, 15%);
        }
    }

    .line {
        height: 2px;
        width: 40px;
        background: $dark;
    }

    .step-name {
        position: absolute;
        top: 36px;
        left: -45%;
        width: 200%;
        text-align: center;
        font-size: 14px;
        color: $dark;
    }
</style>
